import * as z from "zod/v4";

export const getAMPGoogleFormURL = {
  name: "getAMPGoogleFormURL" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ url: z.string().nullable() }),
};
